
<template lang="pug">
transition(name="fade")
  #debug-info.debug-info(v-if="isShowDebug")
    .hide-debug-info(@click="hideDebug")
      p close
    .debug-info__inner
      .general
        p.info-title general
        p.general-info-value {{configText}}
      .renderer-info
        p.info-title renderer info
        ul
          li.programs programs:
            span.programs-value {{programs}}
          li.geometries geometries:
            span.geometries-value {{geometries}}
          li.textures textures:
            span.textures-value {{textures}}
          li.drawcalls drawcalls:
            span.drawcalls-value {{drawcalls}}
          li.lines lines:
            span.lines-value {{lines}}
          li.points points:
            span.points-value {{points}}
          li.triangles triangles:
            span.triangles-value {{triangles}}
      .time-info
        p.info-title time info
        .time-info-value
</template>

<script>
import {mapState, mapMutations} from 'Vuex'
export default {
  props:{
  },
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapState('debug', {isShowDebug: 'isShowDebug', renderInfo: 'renderInfo', config: 'viewerConfig'}),
    programs(){
      return this.renderInfo['programs'] ? this.renderInfo['programs'].length : 0
    },
    geometries(){
      return this.renderInfo['memory'] ? this.renderInfo['memory'].geometries : 0
    },
    textures(){
      return this.renderInfo['memory'] ? this.renderInfo['memory'].textures : 0
    },
    drawcalls(){
      return this.renderInfo['render'] ? this.renderInfo['render'].calls : 0
    },
    lines(){
      return this.renderInfo['render'] ? this.renderInfo['render'].lines : 0
    },
    points(){
      return this.renderInfo['render'] ? this.renderInfo['render'].points : 0
    },
    triangles(){
      return this.renderInfo['render'] ? this.renderInfo['render'].triangles : 0
    },
    configText(){
      if(!this.config.title)
        return '';
      return `title: ${this.config.title}
defaultMaterial: ${this.config.defaultMaterial}
dirLightIntensity: ${this.config.dirLightIntensity}
ambientLightIntensity: ${this.config.ambientLightIntensity}
envIntensity: ${this.config.envIntensity}
cubemap: ${this.config.cubeMap}
subDirLightIntensity: ${this.config.subDirLightIntensity}
`
    }
  },
  methods: {
    ...mapMutations('debug', {hideDebug: 'hide'}),
    onTouchMove(e){
      e.preventDefault();
    },
  },
  created () {},
  mounted () {
  },
}
</script>


<style lang="stylus" scoped>
@import '~/css/mixins.styl' 
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;


.debug-info
  position fixed
  top 0
  left 0
  color black
  background-color rgba(0, 0, 0, 0.5)
  line-height 1.1rem
  min-height 100px
  width 100%
  z-index 100
  white-space: pre-wrap
  word-wrap:break-word

  &__inner
    display flex
    color white
    flex-wrap wrap
    width 100%
    padding 10px 0px 10px 100px
    font-size 12px
    &>*
      margin-right: 10px
      width 200px
    .info-title
      border-bottom white solid 1px
      font-size 14px
    .time-info
      width 300px
    .general
      width 250px


  .hide-debug-info
    color white
    position absolute
    top 60px
    left 10px
    width 50px
    height 50px
    border white 1px solid
    center-child()
    cursor pointer
    

</style>
